import CloneCampaign from "features/Campaign/components/CampaignForm/CloneCampaign";

const CampaignCloneFormScreen = () => {
  return <CloneCampaign />;
};

export default CampaignCloneFormScreen;
